import ImageStaticClass, * as ImageStaticModule from './../../node_modules/ol/source/ImageStatic.js';

class ImageStatic extends ImageStaticClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageStaticModule) {
    if (key !== "default") {
        ImageStatic[key] = ImageStaticModule[key];
    }
}

export default ImageStatic;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageStatic.js';